import type { StaffMember } from '../types';

/**
 * Check if a staff member is a manager
 * Managers are identified by role='manager' (case-insensitive) OR isAdmin=true
 */
export function isManager(staff: StaffMember | null | undefined): boolean {
  if (!staff) return false;
  const roleLower = staff.role?.toLowerCase() || '';
  return roleLower === 'manager' || staff.isAdmin === true;
}

/**
 * Check if a staff member is an admin
 */
export function isAdmin(staff: StaffMember | null | undefined): boolean {
  if (!staff) return false;
  return staff.isAdmin === true;
}

/**
 * Check if staff member can open/close register
 * Only managers can open/close registers
 */
export function canManageRegister(staff: StaffMember | null | undefined): boolean {
  return isManager(staff);
}

/**
 * Check if a staff member can login with email/password
 * Managers, third party testers, and admins can login with email/password
 */
export function canLoginWithEmailPassword(staff: StaffMember | null | undefined): boolean {
  if (!staff) return false;
  const roleLower = staff.role?.toLowerCase() || '';
  return roleLower === 'manager' 
    || roleLower === 'third_party_tester' 
    || roleLower === 'admin'
    || staff.isAdmin === true;
}

